import React from 'react';
import HeaderOne from './header/HeaderOne';
import FooterTwo from './footer/FooterTwo';

const Layout = ({ children }) => (
  <>
    <HeaderOne />
    <main id="main" className="page-wrapper">
      {children}
    </main>
    <FooterTwo />
  </>
);

export default Layout;
